<script>
    import {user_data} from './stores.js';
    import { onMount } from "svelte";
    import Dtemplate from "./components/detailedtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';

    export let chipsdata = [
        {s: true, t: "Primary residence", i:"/img/House.svg", cbf:()=>{$user_data.hometype="PrimaryResidence";}},
        {s: false, t: "Second home", i:"/img/Umbrella.svg", cbf:()=>{$user_data.hometype="SecondHome";}},
        {s: false, t: "Investment", i:"/img/Piggy_bank.svg", cbf:()=>{$user_data.hometype="Investment";}},
    ];

    onMount(async() => {

    });

</script>

<Dtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    title="What type of home are you looking for?"
    show_next_button={false}
    >
    <Chipscompnent
        bind:chipsdata={chipsdata}
    />
    </Progresscomponent>
</Dtemplate>

<style>

</style>